const graficoState = {
  isLoading: false,
  config: {
    embedType: "report",
    tokenType: "Embed",
    accessToken: null,
    embedUrl: "https://app.powerbi.com/reportEmbed?reportId=6b64e411-ef29-4741-bd4c-b54df359f839&groupId=c4a892ec-8d1b-4247-b155-0bbb223555e6",
    embedId: "6b64e411-ef29-4741-bd4c-b54df359f839",
    reportId: "6b64e411-ef29-4741-bd4c-b54df359f839",
    groupId: "c4a892ec-8d1b-4247-b155-0bbb223555e6",
    extraSettings: {
      filterPaneEnabled: false,
      navContentPaneEnabled: false,
      allowFullScreen: false,
    },
  },
  showHideGriphics: false,
  EmbedTokenPowerBi: null,
  IsSuccessGetToken: false,
};

export default graficoState;

